// File Metadata:
// Filename: index.js
// Version: 1.02
// Created: 2025-03-19 22:33:39
// Last Modified: 2026-03-01
// Authors: [Your Name], Claude 3.7 Sonnet, GitHub Copilot
// Description: Redux store configuration with RTK Query integration

import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { baseApi } from './api/baseApi';
import '../features/Auth/store/authApi'; // Import to register auth endpoints
import '../features/Widgets/store/widgetApi'; // Import to register widget endpoints
import '../features/Chat/store/api/chatApi'; // Import to register chat endpoints
import '../features/Checklist/store/api/checklistApi'; // Import to register checklist endpoints
import '../features/Todos/store/todoRtkApi'; // Import to register todo endpoints
import '../features/Chores/store/choresRtkApi'; // Import to register chores endpoints
import '../features/Profile/store/profileApi'; // Import to register profile endpoints
import '../features/Rewards/store/pointsRewardsRtkApi'; // Import to register rewards endpoints
import userReducer from './slices/userSlice';
import chatReducer from '../features/Chat/store/slices/chatSlice';
import usersReducer from './slices/usersSlice';
import choreViewPreferenceReducer from '../features/Chores/store/choreViewPreferenceSlice';
import profileReducer from '../features/Profile/store/profileSlice';
import widgetReducer from '../features/Widgets/store/widgetSlice';
import timerReducer from '../features/Timer/timerSlice';

const rootReducer = combineReducers({
  // RTK Query API reducer
  [baseApi.reducerPath]: baseApi.reducer,
  
  // Existing reducers (will be gradually migrated)
  user: userReducer,
  chat: chatReducer,
  users: usersReducer,
  choreViewPreference: choreViewPreferenceReducer,
  profile: profileReducer,
  widgets: widgetReducer,
  timer: timerReducer
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(baseApi.middleware),
  devTools: process.env.NODE_ENV !== 'production'
});